import { useObjectDatesMapper } from './Helper';
import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface ProjectScratchpad {
  id: number;
  projectId: number;
  text?: string;
  updatedAt: Date;
}

export interface UpdateScratchpadRequest {
  text?: string;
}

export const PROJECT_SCRATCHPAD_UPDATED_EVENT = 'PROJECT_SCRATCHPAD_UPDATED';

export function useProjectScratchpadService() {
  const api = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const {
    mapSingle,
  } = useObjectDatesMapper<ProjectScratchpad>([], ['updatedAt']);

  const get = async (projectId: number): Promise<ProjectScratchpad | null> => {
    const result = await api.get(`/projects/${projectId}/scratchpad`);

    if (result) {
      return mapSingle(result);
    } else {
      return null;
    }
  };

  const update = async (projectId: number, request: UpdateScratchpadRequest): Promise<void> => {
    await api.put(`/projects/${projectId}/scratchpad`, request);

    eventsPublisher.publish(PROJECT_SCRATCHPAD_UPDATED_EVENT, { projectId });
  };

  return {
    get,
    update,
  };
}
